import React from "react";
import { useSettings, resolveImage } from "../lib/settings";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "./ui/carousel";
import { T } from "../lib/autoTranslate";

const Guides = () => {
  const { settings } = useSettings();
  const s = settings || {};
  const guides = s.guides_list || [];

  return (
    <section className="section bg-[var(--ri-cream-2)]">
      <div className="container-x">
        <p className="eyebrow mb-3 text-center">Meet the team</p>
        <h2 className="font-serif-display text-[32px] md:text-[42px] leading-[1.08] text-center">
          <T>{s.guides_section_title || "Our Guides"}</T>
        </h2>
        {s.guides_section_intro && (
          <p className="mt-4 max-w-[620px] mx-auto text-center text-[15.5px] leading-[1.75] text-[var(--ri-ink-soft)]">
            <T>{s.guides_section_intro}</T>
          </p>
        )}

        {guides.length > 0 && (
          <div className="mt-10">
            <Carousel opts={{ align: "start", loop: true }} className="w-full">
              <CarouselContent>
                {guides.map((g, i) => (
                  <CarouselItem key={i} className="sm:basis-1/2 lg:basis-1/4">
                    <div className="h-full rounded-2xl overflow-hidden border border-[var(--ri-border)] bg-[#fffdf7]">
                      <div className="aspect-[4/5] bg-[var(--ri-cream)]">
                        {g.image ? (
                          <img
                            src={resolveImage(g.image)}
                            alt={g.name}
                            loading="lazy"
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="w-full h-full flex items-center justify-center text-[11px] uppercase tracking-widest text-[var(--ri-muted)]">
                            No photo yet
                          </div>
                        )}
                      </div>
                      <div className="p-4">
                        <h4 className="font-serif-display text-[18px] leading-[1.2]">{g.name}</h4>
                        {g.bio && (
                          <p className="mt-1.5 text-[13px] leading-[1.55] text-[var(--ri-ink-soft)] line-clamp-3">
                            <T>{g.bio}</T>
                          </p>
                        )}
                      </div>
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <div className="flex items-center justify-center gap-2 mt-6">
                <CarouselPrevious className="static translate-y-0 h-9 w-9" />
                <CarouselNext className="static translate-y-0 h-9 w-9" />
              </div>
            </Carousel>
          </div>
        )}
      </div>
    </section>
  );
};

export default Guides;
